import { IResponse } from '../../common/model/Core.model'
import { environment } from '../../util/Environment'
import { apiSlice } from '../store/Api'
import { IAssetMetadataDto, IAssetMetadataSearchByAreaRequestDto, IAssetMetadataSearchRequestDto } from './AssetMetadata.model'

export const assetMetadataApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      assetMetadataSearch: builder.mutation<IResponse, IAssetMetadataSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.asset}/metadata/search`,
            method: 'POST',
            body,
          }
        },
      }),
      assetMetadataGetByArea: builder.mutation<IResponse, IAssetMetadataSearchByAreaRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.asset}/metadata/area`,
            method: 'POST',
            body,
          }
        },
      }),
      assetMetadataGetById: builder.mutation<IAssetMetadataDto, {id: string; fields?: string}>({
        query(parameters) {
          const queryParams = parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.asset}/metadata/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
    }
  },
})

export const {
  useAssetMetadataSearchMutation,
  useAssetMetadataGetByAreaMutation,
  useAssetMetadataGetByIdMutation,
} = assetMetadataApi
